// Chip colors live here and as --fc-chip-* variables in founder-calendar.css.
// Change both together. Text colors are paired for contrast on the 13px chip.

export const CHIP_TONES = ['blue', 'red', 'green', 'yellow', 'purple', 'pink', 'gray', 'beige'];

export function toneForKey(id) {
    const text = String(id || '');
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) hash = (hash * 33 + text.charCodeAt(i)) >>> 0;
    return CHIP_TONES[hash % CHIP_TONES.length];
}

export function leaveTone(approval, personId, colorBy) {
    if (colorBy === 'assignee') return personId ? toneForKey(personId) : 'gray';
    return approval === 'pending' ? 'blue' : 'green';
}
